import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import DuplicateItemForm from "./DuplicateItemForm";

const DuplicateItem = () => {
	return (
		<div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
			<Helmet>
				<title>Item - Duplicate</title>
			</Helmet>
			<Header />
			<div
				className="container-fluid maindiv d-flex flex-column"
				style={{ flexGrow: "1" }}
			>
				<DuplicateItemForm />
			</div>
		</div>
	);
};

export default DuplicateItem;
